import { Box, Heading, Icon, Tooltip } from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { Info } from "lucide-react";
import ExportDataFilterForm from "../../../components/filterForm/ExportDataFilterForm";
import BranchExportDataReport from "../../../components/branches/reports/ticket-info/BranchExportData";
import { resetExportState } from "../../../store/actions/exportActions";

const BranchExportData = () => {
  const dispatch = useDispatch();
  const { organizationId } = useSelector((state) => state.defaultReducer);
  const reportTitle = "Export Ticket Data";

  useEffect(() => {
    document.title = reportTitle;
    return () => {
      dispatch(resetExportState());
    };
  }, [dispatch]);

  return (
    <Box>
      <ExportDataFilterForm />
      <Heading fontSize="34px" color="#222" fontWeight="700">
        {reportTitle}
        <Tooltip.Root>
          <Tooltip.Trigger asChild>
            <Icon as={Info} w={5} h={5} ml={2} cursor="pointer" />
          </Tooltip.Trigger>
          <Tooltip.Positioner>
            <Tooltip.Content>
              Export ticket data for a selected branch and month as a CSV file.
            </Tooltip.Content>
          </Tooltip.Positioner>
        </Tooltip.Root>
      </Heading>
      {organizationId ? <BranchExportDataReport /> : null}
    </Box>
  );
};

export default BranchExportData;
